import { Box, Flex, Grid, Section } from '@radix-ui/themes';

import { AvailableContentSection } from './AvailableContent/AvailableContentSection';
import { GlobalInfoSection } from './GlobalInformation/GlobalInfoSection';
import { TechnicalDetailsSection } from './GlobalInformation/TechnicalDetailsSection';
import { SummarySection } from './Summary/SummarySection';

export const PreviewTab = () => {
    return (
        <Section size={'1'}>
            <Section>
                <Flex gap={'8'} justify={'between'} align={'stretch'}>
                    <Box px={'5%'} width={{ initial: '100%', md: '45%' }}>
                        <SummarySection />
                    </Box>
                </Flex>
            </Section>

            <Section>
                <Grid
                    columns='repeat(auto-fit, minmax(min(100%, 450px), 1fr))'
                    gap={'9'}
                    px={'5%'}
                >
                    <GlobalInfoSection />
                    <TechnicalDetailsSection />
                </Grid>
            </Section>

            <Section>
                <AvailableContentSection />
            </Section>
        </Section>
    );
};
